import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeliveryOptions } from 'src/app/_models/enums/DeliveryOptions';
import { FinanceService } from 'src/app/_services/finance.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { ConfirmationService } from 'src/app/shared/confirmDialog/services/confirmation.service';

export interface DialogData {
  invoiceData: any;
}
@Component({
  selector: 'app-invoice-send-options',
  templateUrl: './invoice-send-options.component.html',
  styleUrls: ['./invoice-send-options.component.css']
})
export class InvoiceSendOptionsComponent implements OnInit {
  invoiceData:any = {};
  deliveryMetod:number = 1;
  selectedOption: DeliveryOptions;
  showMenu = false;
  buttonLabel = 'POSLATI NA EFAKTURE';

  constructor(public dialogRef: MatDialogRef<InvoiceSendOptionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,private notify: NotificationService,private confirmationService:ConfirmationService,private financeService:FinanceService) { }

  ngOnInit(): void {
    this.invoiceData = this.data.invoiceData
    // console.log("🚀 ~ InvoiceSendOptionsComponent ~ ngOnInit ~ this.invoiceData:", this.invoiceData)
    
  }
  toggleButton() {
    switch (this.deliveryMetod) {
      case DeliveryOptions.SendToEInvoicesAPI:
          this.onSent();
          break;
      case DeliveryOptions.SendToEInvoicesAPIAndEmail:
        // this.notify.success(`U izradi`);
        // this.openDialog();
        this.onSentToApiAndEmail()

          break;
      case DeliveryOptions.SendToEmail:
          this.onSentToEmail();
          break;
      default:
          break;
  }
}
onSelect(option: DeliveryOptions) {
    this.selectedOption = option;
    this.showMenu = false; // Close menu after selection if needed

    switch (option) {
        case DeliveryOptions.SendToEInvoicesAPI:
            this.sendToEInvoicesAPI();
            break;
        case DeliveryOptions.SendToEInvoicesAPIAndEmail:
            this.sendToEInvoicesAPIAndEmail();
            break;
        case DeliveryOptions.SendToEmail:
            this.sendToEmail();
            break;
        default:
            break;
    }
}

  sendToEInvoicesAPI() {
      this.setButtonLabelAndDeliveryMethod('POSLATI NA EFAKTURE', DeliveryOptions.SendToEInvoicesAPI);
  }

  sendToEInvoicesAPIAndEmail() {
      this.setButtonLabelAndDeliveryMethod('POSLATI NA EFAKTURE I EMAIL', DeliveryOptions.SendToEInvoicesAPIAndEmail);
  }

  sendToEmail() {
      this.setButtonLabelAndDeliveryMethod('POSLATI NA EMAIL', DeliveryOptions.SendToEmail);
  }

  setButtonLabelAndDeliveryMethod(label: string, method: DeliveryOptions) {
      this.buttonLabel = label;
      this.deliveryMetod = method;
  }
  onSentToApiAndEmail(){
    const currTime = new Date();
    this.confirmationService.confirm({
      header: 'Potvrda slanja na e-fakturu i email',
      message: currTime.getHours() >= 0 && currTime.getHours() <= 6 ? 'Servis trenutno nije u funkciji' : 'Da li želite da pošaljete račun na e-fakture?',
      accept: () => {
        // this.loading = true;
        this.financeService.sendInvoiceToEInvoiceAPI(this.invoiceData.id).subscribe(
          (response) => {
          debugger

            // console.log('Uspešno poslato na server', response);
            this.notify.success(`Racun je uspešno poslat`);
            // this.router.navigate(['/finance/account']);
    
          },
          (error) => {
          debugger

            this.notify.error('Greška prilikom slanja na server');
          }
        );
        this.financeService.sendInvoiceToEmail(this.invoiceData.id).subscribe(
          (response) => {
          // debugger
            if (response) {
            this.notify.success(`Racun je uspešno poslat`);
             return 
            }
            // console.log('Uspešno poslato na email', response);
            this.notify.error(`Greška prilikom slanja`);
            // this.router.navigate(['/finance/account']);
    
          },
          (error) => {
          // debugger

            this.notify.error('Greška prilikom slanja');
          }
        );
      }
    })
  }
  onSent(){
    const currTime = new Date();
    this.confirmationService.confirm({
      header: 'Potvrda slanja na e-fakturu ',
      message: currTime.getHours() >= 0 && currTime.getHours() <= 6 ? 'Servis trenutno nije u funkciji' : 'Da li želite da pošaljete račun na e-fakture?',
      accept: () => {
        // this.loading = true;
        this.financeService.sendInvoiceToEInvoiceAPI(this.invoiceData.id).subscribe(
          (response) => {
          // debugger

            // console.log('Uspešno poslato na server', response);
            this.notify.success(`Racun je uspešno poslat`);
            // this.router.navigate(['/finance/account']);
    
          },
          (error) => {
          debugger

            this.notify.error('Greška prilikom slanja na server');
          }
        );
      }
    })
  }
  onSentToEmail(){
    this.confirmationService.confirm({
      header: 'Potvrda slanja na e-mail ',
      message:  'Da li želite da pošaljete račun na e-mail',
      accept: () => {
        // this.loading = true;
        this.financeService.sendInvoiceToEmail(this.invoiceData.id).subscribe(
          (response) => {
          // debugger
            if (response) {
            this.notify.success(`Racun je uspešno poslat`);
             return 
            }
            // console.log('Uspešno poslato na email', response);
            this.notify.error(`Greška prilikom slanja`);
            // this.router.navigate(['/finance/account']);
    
          },
          (error) => {
          // debugger

            this.notify.error('Greška prilikom slanja');
          }
        );
      }
    })
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

}
